module.exports = __webpack_public_path__ + "img/pop_001@2x.982aee1b.png";